import axios from 'axios'

export const SERVER_URL = process.env.REACT_APP_SERVER_URL

export interface FeatureFlags {
    meta_integration: boolean
    [key: string]: boolean
}

export const fetchFeatureFlags = async (): Promise<FeatureFlags> => {
    try {
        const response = await axios.get(`${SERVER_URL}/api/features`)
        return response.data
    } catch (error) {
        console.error('Failed to fetch feature flags', error)
        // Return default values if fetch fails
        return {
            meta_integration: false
        }
    }
}
